
import gsap from 'gsap'
import { lockScroll, trapFocus } from '../helpers'

class Drawer {
    constructor(element) {
        this.element = element
        this.video = this.element.querySelector('video')
        this.tabs = [...this.element.querySelectorAll('[data-tab]')]

        this.triggers = [...document.querySelectorAll('[data-anchor]')]
        this.closeBtn = this.element.querySelector('.btn-close')
        this.colorTable = this.tabs.filter((tab) => tab.dataset.tab === 'colors')[0]?.querySelector('table')

        this.hideTabs()

        this.bindings()

        if (this.colorTable) this.setColorTable()
    }

    bindings() {
        this.triggers.forEach((trigger) => {
            const href = trigger.dataset.anchor

            trigger.addEventListener('click', (e) => this.open(e, href))
        })

        this.closeBtn.addEventListener('click', this.close.bind(this))

        // Make clicking outside of the element close it only after opening
        document.addEventListener('click', (e) => {
            if (this.element.contains(e.target)) return
            if (this.opened) this.close(e)
        })
    }

    hideTabs() {
        this.tabs.forEach((tab) => {
            tab.classList.add('hidden')
        })
    }

    open(e, href) {
        e.preventDefault()

        this.hideTabs()

        lockScroll(true)


        if (href) {
            this.activeTab = this.element.querySelector(`[data-tab="${href}"]`)
        } else {
            this.activeTab = this.tabs[0]
        }

        this.activeTab.classList.remove('hidden')

        gsap.set(this.element, { autoAlpha: 1 })

        gsap.to(this.element, {
            x: 0,
            duration: 0.3,
            ease: 'circ.out',
            onComplete: () => {
                this.opened = true
                trapFocus(this.element)
            }
        })
    }

    close(e) {

        e.preventDefault()

        gsap.to(this.element, {
            x: '100%',
            duration: 0.3,
            ease: 'circ.in',
            onComplete: () => {
                this.opened = false

                gsap.set(this.element, { autoAlpha: 0 })
                lockScroll(false)
            }
        })
    }

    setColorTable() {
        const colorValues = this.colorTable.querySelectorAll('.color-value')

        const highlightRelatedCells = (cell) => {
            const rowIndex = cell.parentElement.rowIndex
            const colIndex = cell.cellIndex

            for (let i = 0; i < this.colorTable.rows.length; i++) {
                this.colorTable.rows[i].cells[colIndex].classList.add('highlight')
            }

            const row = this.colorTable.rows[rowIndex]
            for (let j = 0; j < row.cells.length; j++) {
                row.cells[j].classList.add('highlight')
            }
        }

        const removeHighlight = () => {
            const highlightedCells = document.querySelectorAll('.highlight')
            highlightedCells.forEach(cell => {
                cell.classList.remove('highlight')
            })
        }

        colorValues.forEach(cell => {
            cell.addEventListener('mouseenter', () => {
                highlightRelatedCells(cell)
            })

            cell.addEventListener('mouseleave', () => {
                removeHighlight()
            })
        })
    }
}

// IIFE to invoke component on mount
(function init() {
    const drawerEls = document.querySelectorAll('[data-drawer]')

    drawerEls.forEach((el, i, arr) => {
        if (el.getAttribute('bound') !== null) return

        const drawer = new Drawer(el)

        el.setAttribute('bound', '')

        const id = arr.length > 1 ? `Drawer_${i}` : 'Drawer'

        self.Decimal.components[id] = { ...drawer, async: true }
    })
})()
